"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedInteger = void 0;
var tslib_1 = require("tslib");
var isEqual_1 = (0, tslib_1.__importDefault)(require("lodash/fp/isEqual"));
var cond_1 = (0, tslib_1.__importDefault)(require("lodash/fp/cond"));
var stubTrue_1 = (0, tslib_1.__importDefault)(require("lodash/fp/stubTrue"));
var padWithLeadingZeros = function (value, totalLength) {
    return String(value).padStart(totalLength, '0');
};
var getHexadecimalValue = function (value) {
    return Math.abs(value).toString(16).toUpperCase();
};
exports.getFormattedInteger = (0, cond_1.default)([
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, '0'); },
        function (params) {
            return params.value.toString();
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, '#,##0'); },
        function (params) {
            return Number(params.value).toLocaleString('en-us');
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'D'); },
        function (params) {
            return params.value.toString();
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'D6'); },
        function (params) {
            var valueWithLeadingZeros = padWithLeadingZeros(params.value, 6);
            return valueWithLeadingZeros;
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'X'); },
        function (params) {
            var hexValue = getHexadecimalValue(params.value);
            return hexValue;
        },
    ],
    [
        function (params) { return (0, isEqual_1.default)(params.plxFormat, 'X4'); },
        function (params) {
            var hexValue = getHexadecimalValue(params.value);
            var hexValueWithLeadingZeros = padWithLeadingZeros(hexValue, 4);
            return hexValueWithLeadingZeros;
        },
    ],
    [
        stubTrue_1.default,
        function (params) {
            return params.value.toString();
        },
    ],
]);
